
import { TiptapEditor, Collapsible, InputValidationMixin } from 'fourwaves-shared/components';
import { TiptapExtension } from 'fourwaves-shared';
import { Component, Emit, mixins, Prop, Ref } from 'nuxt-property-decorator';

@Component({
  components: {
    TiptapEditor,
    Collapsible,
  },
})
export default class RichTextEditor extends mixins(InputValidationMixin) {
  @Prop(String) readonly name!: string;
  @Prop(String) readonly label!: string;
  @Prop({ type: String, default: 'text' }) readonly type!: string;
  @Prop(String) readonly placeholder!: string;
  @Prop(String) readonly value!: string;
  @Prop(Boolean) readonly readonly!: boolean;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(String) readonly help!: string;
  @Prop(Boolean) readonly autofocus!: boolean;

  /* Extensions */
  @Prop({ type: Boolean, default: true }) readonly isBasicStylesAllowed!: boolean;
  @Prop(Boolean) readonly isLinkAllowed!: boolean;
  @Prop(Boolean) readonly isImageAllowed!: boolean;
  @Prop(Boolean) readonly isHeadingAllowed!: boolean;
  @Prop(Boolean) readonly isListAllowed!: boolean;
  @Prop(Boolean) readonly isTextAlignmentAllowed!: boolean;
  @Prop(Boolean) readonly isMediaEmbedAllowed!: boolean;
  @Prop(Boolean) readonly isHorizontalLineAllowed!: boolean;

  @Ref() readonly tiptapEditor!: TiptapEditor;

  isFocused = false;
  initialValue = this.value;

  @Emit() input(_value: string) {}
  @Emit() focus() {}
  @Emit() blur() {}
  @Emit() keydownEnter(_event: KeyboardEvent) {}

  get extensions() {
    const extensions: TiptapExtension[] = [];

    if (this.isBasicStylesAllowed) {
      extensions.push(
        TiptapExtension.Bold,
        TiptapExtension.Italic,
        TiptapExtension.Underline,
        TiptapExtension.Subscript,
        TiptapExtension.Superscript,
      );
    }

    if (this.isHeadingAllowed) {
      extensions.push(TiptapExtension.Heading);
    }

    if (this.isLinkAllowed) {
      extensions.push(TiptapExtension.Link);
    }

    if (this.isListAllowed) {
      extensions.push(TiptapExtension.BulletList, TiptapExtension.OrderedList);
    }

    if (this.isTextAlignmentAllowed) {
      extensions.push(TiptapExtension.TextAlign);
    }

    if (this.isMediaEmbedAllowed) {
      extensions.push(TiptapExtension.Video);
    }

    if (this.isHorizontalLineAllowed) {
      extensions.push(TiptapExtension.HorizontalLine);
    }

    return extensions;
  }

  get inputClassNames() {
    return [
      'js-rte-' + this.name,
      {
        '-destructive': this.hasValidationError,
      },
    ];
  }

  get footerText() {
    if (this.hasValidationError) return this.firstValidationError;
    return this.help || '';
  }

  public beforeDestroy() {
    this.$validator.reset();
  }

  public updateValue(value: string) {
    this.input(value);
  }

  public insertString(value: string) {
    if (!this.tiptapEditor) return;
    this.tiptapEditor.editor?.chain().focus().insertContent(value).run();
  }
}
